const { RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { name, text, image } = attributes;

  return (
    <>
      <div className="swiper-slide CardAdvantage">
        <header className="CardAdvantage-head">
          <figure className="CardAdvantage-image">
            <img
              src={image.src}
              width={image.width}
              height={image.height}
              title={image.alt}
              alt={image.alt}
            />
          </figure>

          <RichText.Content
            tagName="h3"
            value={name}
            className="CardAdvantage-name"
          />
        </header>

        <p className="CardAdvantage-info">{text}</p>
      </div>
    </>
  );
};

export default Save;
